import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthAdminGuard } from './core/guards/auth-admin.guard';
import { FooterComponent } from './footer/footer.component';
import { InicioComponent } from './inicio/inicio.component';
import { BotonesComponent } from './botones/botones.component';
import { LoadingPedidoComponent } from './loading-pedido/loading-pedido.component';
import { EsperarServicioComponent } from './esperar-servicio/esperar-servicio.component';
import { PoliticaCookiesComponent } from './politica-cookies/politica-cookies.component';

const routes: Routes = [
  /************ componentes que se pueden cargar sin loguearse ***********/
  { path: 'login', component: LoginComponent },
  { path: 'footer', component: FooterComponent },
  { path: 'inicio', component: InicioComponent },
  { path: 'ServciosMesa', component: BotonesComponent },
  { path: 'pedidoMesa', component: LoadingPedidoComponent },
  { path: 'errorTiempo', component: EsperarServicioComponent },
  { path: 'politica-cookies', component: PoliticaCookiesComponent },

  /************************* Estos son rutas por defecto ************************/

  { path: '', redirectTo: '/inicio', pathMatch: 'full' },
  { path: '**', redirectTo: '/inicio'}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
